import React, { memo } from 'react';

import Font from '@/assets/fonts/index.tsx';
import ViewportHandler from '@/components/atomic/molecules/utils/viewport/viewport-handler';

const BeforeEntryComponent: React.FC = () => (
	<>
		<Font />
		<ViewportHandler />
	</>
);

export default memo(BeforeEntryComponent);
